// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-vessel-tsx": () => import("./../../../src/pages/about-vessel.tsx" /* webpackChunkName: "component---src-pages-about-vessel-tsx" */),
  "component---src-pages-features-tsx": () => import("./../../../src/pages/features.tsx" /* webpackChunkName: "component---src-pages-features-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-why-vessel-tsx": () => import("./../../../src/pages/why-vessel.tsx" /* webpackChunkName: "component---src-pages-why-vessel-tsx" */),
  "component---src-templates-blog-post-tsx": () => import("./../../../src/templates/blog_post.tsx" /* webpackChunkName: "component---src-templates-blog-post-tsx" */),
  "component---src-templates-learn-tsx": () => import("./../../../src/templates/learn.tsx" /* webpackChunkName: "component---src-templates-learn-tsx" */)
}

